import { PRDVisualContext } from "../PRD/PRD";
import { FeaturePRD } from "@/types/issues";

export const getContextFromFeaturePrd = (featurePrd?: FeaturePRD) => {
  if (!featurePrd) {
    return {
      contextWithImages: [],
      userSelectionContext: [],
    };
  }

  let userSelectionContext = [],
    contextWithImages = [];
  const canvasContext =
    featurePrd?.canvas_visual_context as any as PRDVisualContext;

  if (canvasContext?.length) {
    // @ts-expect-error TS2322
    contextWithImages = canvasContext
      .filter((context) => context.url)
      .map((context) => ({
        url: context.url,
        name: context.name || "Visual context",
        type: context.type || "image",
        context: context.text,
      }));

    // @ts-expect-error TS2322
    userSelectionContext = canvasContext.filter((context) => !context.url);
  }

  return {
    contextWithImages: contextWithImages || [],
    userSelectionContext: userSelectionContext || [],
  };
};

export const getFileContentsWithLineNumbers = (fileContents?: string) => {
  if (!fileContents) {
    return "";
  }

  return fileContents
    .split("\n")
    .map((line, index) => `${index + 1} | ${line}`)
    .join("\n");
};
